import React from 'react';

const WindowFrame = ({ children, dataStep, whColor, wbColor }) =>
  <div className="window-app" data-step={dataStep}>
    <div className="window-header" style={{ backgroundColor: whColor }}>
      <ul className="buttons">
        <li className="button" />
        <li className="button" />
        <li className="button" />
      </ul>
    </div>
    <div className="window-body" style={{ backgroundColor: wbColor }}>
      {children}
    </div>
  </div>;

export default WindowFrame;



// WEBPACK FOOTER //
// ./src/components/OnboardingFlow/components/WindowFrame.js